import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import WarningsIcon from '@styles/webdesktop/Icons/warning.svg';
const ICON_MAP = {
    none: null,
    warning: _jsx(WarningsIcon, {})
};
export function NotificationMessage({ type, text }) {
    const icon = ICON_MAP[type];
    return (_jsxs("div", { className: `notification-message ${type}`, children: [_jsx("div", { className: "notification-message-icon", children: icon }), _jsx("div", { className: "notification-message-text", children: text })] }));
}
